/**
 * Spinner — wrapper sobre Polaris Spinner.
 * Visual: idéntica a Polaris Spinner hoy.
 * Beneficio: los componentes no importan directamente @shopify/polaris.
 * Migración futura: cambiar solo este archivo.
 */
import { Spinner as PolarisSpinner } from '@shopify/polaris';

interface SpinnerProps {
  size?: 'small' | 'large';
  label?: string;
}

export function Spinner({ size = 'large', label }: SpinnerProps) {
  return <PolarisSpinner size={size} accessibilityLabel={label ?? 'Cargando'} />;
}
